import React from 'react';
import Filters from '../../components/Filters';
import { Form } from 'react-bootstrap';
import MultiSelectField from '../../components/form/MultiSelectField';
import { faInfoCircle, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FiltersPartial = (props) => {
  const { filtersModel, setFiltersModel } = props;

  const onStateSelect = (selectedItems, selectedItem) => {
    setFiltersModel((prevState) => {
      return {...prevState, state_ids: [...(prevState.state_ids || []), selectedItem.id ]}
    })
  }

  const onStateRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return {...prevState, state_ids: prevState.state_ids.filter((id) => id !== removedOption.id )}
    })
  }

  const onZoneSelect = (selectedItems, selectedItem) => {
    setFiltersModel((prevState) => {
      return {...prevState, zone_ids: [...(prevState.zone_ids || []), selectedItem.id ]}
    })
  }

  const onZoneRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return {...prevState, zone_ids: prevState.zone_ids.filter((id) => id !== removedOption.id )}
    })
  }

  const onDistrictsSelect = (selectedItems, selectedItem) => {
    setFiltersModel((prevState) => {
      return {...prevState, district_ids: [...(prevState.district_ids || []), selectedItem.id ]}
    })
  }

  const onDistrictsRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return {...prevState, district_ids: prevState.district_ids.filter((id) => id !== removedOption.id )}
    })
  }

  const onCircleSelect = (selectedItems, selectedItem) => {
    setFiltersModel((prevState) => {
      return {...prevState, branch_ids: [...(prevState.branch_ids || []), selectedItem.id ]}
    })
  }

  const onCircleRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return {...prevState, branch_ids: prevState.branch_ids.filter((id) => id !== removedOption.id )}
    })
  }

  const onClusterSelect = (selectedItems, selectedItem) => {
    setFiltersModel((prevState) => {
      return {...prevState, cluster_ids: [...(prevState.cluster_ids || []), selectedItem.id ]}
    })
  }

  const onClusterRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return {...prevState, cluster_ids: prevState.branch_ids.filter((id) => id !== removedOption.id )}
    })
  }

  return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
    <div>
      <Form.Group className="mb-3">
        <Form.Label>Zone</Form.Label>
        <MultiSelectField
          options={[]}
          fieldName="zone_ids"
          stateModel={filtersModel}
          dynamicOptions={{
            dependsOnFields: [],
            apiName: "zones",
            dataAttr: "zones",
          }}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={onZoneSelect}
          onRemove={onZoneRemove}
          placeholder="Select State"
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Circle</Form.Label>
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={(props) =>
            <Tooltip id="search-ifo-tooltip" {...props} style={{ ...props.style, fontSize: "11px" }}>
              Please Select Zone before selecting branch
            </Tooltip>}
        >
          <FontAwesomeIcon
            className="icon ms-2"
            icon={faInfoCircle}
            style={{ cursor: 'pointer', color: 'red' }}
          />
        </OverlayTrigger>
        <MultiSelectField
          options={[]}
          fieldName="branch_ids"
          stateModel={filtersModel}
          dynamicOptions={{
            dependsOnFields: ['zone_ids'],
            apiName: "branches",
            dataAttr: "branches",
          }}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={onCircleSelect}
          onRemove={onCircleRemove}
          placeholder="Select Circle"
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Cluster</Form.Label>
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={(props) =>
            <Tooltip id="search-ifo-tooltip" {...props} style={{ ...props.style, fontSize: "11px" }}>
              Please Select Cirlce before selecting cluster
            </Tooltip>}
        >
          <FontAwesomeIcon
            className="icon ms-2"
            icon={faInfoCircle}
            style={{ cursor: 'pointer', color: 'red' }}
          />
        </OverlayTrigger>
        <MultiSelectField
          options={[]}
          fieldName="cluster_ids"
          stateModel={filtersModel}
          dynamicOptions={{
            dependsOnFields: ["branch_ids"],
            apiName: "clusters",
            dataAttr: "clusters",
          }}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={onClusterSelect}
          onRemove={onClusterRemove}
          placeholder="Select Cluster"
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>State</Form.Label>
        <MultiSelectField
          options={[]}
          fieldName="state_ids"
          stateModel={filtersModel}
          dynamicOptions={{
            dependsOnFields: [],
            apiName: "states",
            dataAttr: "states",
          }}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={onStateSelect}
          onRemove={onStateRemove}
          placeholder="Select State"
        />
      </Form.Group>
      {/*<Form.Group className="mb-3">
        <Form.Label>District</Form.Label>
        <MultiSelectField
          options={[]}
          fieldName="district_ids"
          stateModel={filtersModel}
          dynamicOptions={{
            dependsOnFields: [],
            apiName: "districts",
            dataAttr: "districts",
          }}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={onDistrictsSelect}
          onRemove={onDistrictsRemove}
          placeholder="Select District"
        />
      </Form.Group>*/}
    </div>
  </Filters>
};

export default FiltersPartial;

